module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/calculator/calculator-item/shared/main/vehicle/car/car.component.css
// module id = ./src/app/components/calculator/calculator-item/shared/main/vehicle/car/car.component.css
// module chunks = main